import React, { useEffect, useState } from 'react';
import './nonMembersList.scss';
import { Tabs, Table, Avatar, Button, Tag, Space, Row, Col, Input, Modal, List } from 'antd';
import { PlusOutlined, EyeOutlined, SearchOutlined, CloseOutlined, ExclamationCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { appDispatch, RootState } from '../../../app/store';
import { fetchONRoles, fetchONUserDetails, fetchRequestLists, resetFetchONSpecialities } from '../../../features/superAdmin/requestLIsts/requestListsSlice';
import { toast } from 'react-toastify';
import { Skeleton, Card } from 'antd';
import { UserDetailsModal } from '../requestLists/components/userDetailsModal/UserDetailsModal';
import { DEFAULT_PROFILE_IMAGE, SUPER_ADMIN_API_URL } from '../../../constants';
import SimpleButton from '../../../components/buttons/simpleButton/SimpleButton';
import { LiaSearchSolid } from 'react-icons/lia';
import NonMemberListAction from './nonMemberListAction';
import { deleteMembers, fetchDeletedMembersList, fetchMembersList, fetchNonMembersList, filterMembers } from '../../../features/members/membersSlice';
import { fetchNotesList } from '../../../features/users/usersSlice';


interface UserData {
  key: string;
  name: string;
  email: string;
  status: string;
  avatar: string;
}

export const NonMembersList = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch<appDispatch>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [activeTab, setActiveTab] = useState<string>('nonMembers');
  const [searchquery, setSearchquery] = useState<string>("");

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedAlphabet, setSelectedAlphabet] = useState("All");
  const [selectedSpeciality, setSelectedSpeciality] = useState("");
  const [selectedSite, setSelectedSite] = useState("");
  const [selectedActive, setSelectedActive] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [licenseNumbers, setLicenseNumbers] = useState<string[]>([]);
  const [updatedData, setUpdatedData] = useState<any[]>([]);
  const [isUserDetailModalVisible, setIsUserDetailModalVisible] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState<React.Key[]>([]);
  const {
    userDetailsData,
    isLoading: isUserDetailsLoading,
  } = useSelector((state: RootState) => state.requestLsts.fetchONUserDetails);
  const nonMembersList = useSelector((state: RootState) => state.members.fetchNonMembersList.fetchNonMembersListData);
  const membersList = useSelector((state: RootState) => state.members.fetchMembersList.fetchMembersListData);
  const deletedMembersList = useSelector((state: RootState) => state.members.fetchDeletedMembersList.fetchDeletedMembersListData);
  const { confirm } = Modal;

  console.log(nonMembersList, "nonMembersList")

  const handleShowLicenses = (numbers: string[]) => {
    setLicenseNumbers(numbers);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setLicenseNumbers([]);
  };

  const {
    fetchNonMembersListData,
    isLoading,
    totalCount
  } = useSelector((state: RootState) => state.members.fetchNonMembersList);

  useEffect(() => {
    setUpdatedData(updatedData)
    console.log(updatedData, "updateddata")
  }, [updatedData])

  useEffect(() => {
    if (activeTab === "nonMembers") {
      setUpdatedData(nonMembersList || []);
    } else if (activeTab === "members") {
      setUpdatedData(membersList || []);
    } else if (activeTab === "deleted") {
      setUpdatedData(deletedMembersList || []);
    }
  }, [activeTab, nonMembersList, membersList, deletedMembersList]);

  useEffect(() => {
    const currentTab = TABS.find(tab => tab.key === activeTab);
    const thunkArgs = { searchquery: searchquery || "", pageNumber: 1 };

    if (currentTab?.key === 'nonMembers') {
      dispatch(fetchNonMembersList(thunkArgs));
    } else if (currentTab?.key === 'members') {
      dispatch(fetchMembersList(thunkArgs));
    } else if (currentTab?.key === 'deleted') {
      dispatch(fetchDeletedMembersList(thunkArgs));
    }
  }, [activeTab]);

  useEffect(() => {
    const thunkArgs = {
      searchquery: searchquery || "",
      pageNumber: 1,

    }

    dispatch(fetchNonMembersList(thunkArgs));
    dispatch(fetchMembersList(thunkArgs));
    dispatch(fetchDeletedMembersList(thunkArgs));
    dispatch(fetchONRoles({}))

  }, [dispatch]);

  const handleDeleteUser = () => {
    confirm({
      title: "Delete confirmation",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to delete?",
      centered: true,
      onOk() {
        const payload = {
          is_on_user_delete: true,
          is_on_account_delete: true,
          on_user_ids: selectedRowIds

        };
        dispatch(deleteMembers(payload))
          .then((data) => {
            if (data.payload.isSuccess) {
              toast.success(data.payload.message);
              resetTableSelection();
              setTimeout(() => {
                dispatch(fetchMembersList({ searchquery, pageNumber })); // refresh
                dispatch(fetchNonMembersList({ searchquery, pageNumber })); // refresh
                dispatch(fetchDeletedMembersList({ searchquery, pageNumber })); // refresh
              }, 500)


            } else {
              toast.error(data.payload);
            }
          })
          .catch((error) => {
            console.error("Delete failed:", error);
          });
      },
      onCancel() { },
    });
  };


  const handleSearch = () => {
    const params = {
      searchquery: searchquery ? searchquery : ""
    }
    if (activeTab === "members") {
      dispatch(fetchMembersList(params));

    }
    else if (activeTab === "deleted") {
      dispatch(fetchDeletedMembersList(params));

    }
    else if (activeTab === "nonMembers") {
      dispatch(fetchNonMembersList(params));

    }
  }


  const rowSelection = {
    selectedRowKeys: selectedRowIds,  // ✅ directly use state
    onChange: (_selectedRowKeys: React.Key[], selectedRowsData: any[]) => {
      setSelectedRowIds(_selectedRowKeys); // ✅ keep keys in sync
      setSelectedRows(selectedRowsData);
    },
  };

  const handleSpecialityChange = (val: string) => {
    setSelectedSpeciality(val);
    const thunkArgs = {}
    dispatch(fetchNonMembersList(thunkArgs));
    dispatch(fetchMembersList(thunkArgs));
    dispatch(fetchDeletedMembersList(thunkArgs));
  };

  const handleSiteChange = (val: string) => {
    setSelectedSite(val);
    const thunkArgs = {}
    dispatch(fetchNonMembersList(thunkArgs));
    dispatch(fetchMembersList(thunkArgs));
    dispatch(fetchDeletedMembersList(thunkArgs));
  };

  const handleActiveChange = (val: string) => {
    setSelectedActive(val);
    const thunkArgs = {}
    dispatch(fetchNonMembersList(thunkArgs));
    dispatch(fetchMembersList(thunkArgs));
    dispatch(fetchDeletedMembersList(thunkArgs));
  };

  const handleRoleChange = (val: string) => {
    setSelectedRole(val);
    const thunkArgs = {}
    dispatch(fetchNonMembersList(thunkArgs));
    dispatch(fetchMembersList(thunkArgs));
    dispatch(fetchDeletedMembersList(thunkArgs));
  };

  const handleClearAll = () => {
    //  setSelectedSpeciality("");

    setSearchquery("");
    const thunkArgs = {}
    dispatch(fetchNonMembersList(thunkArgs));
    dispatch(fetchMembersList(thunkArgs));
    dispatch(fetchDeletedMembersList(thunkArgs));
  };

  const resetTableSelection = () => {
    setSelectedRows([]);
  };

  const TABS = [
    { label: 'Non-Members', key: 'nonMembers', status: 'nonMembers' },
    { label: 'Members', key: 'members', status: 'members' },
    { label: 'Deleted Members', key: 'deleted', status: 'deleted' },
  ];

  useEffect(() => {
    const currentTab = TABS.find(tab => tab.key === activeTab);
    if (currentTab?.key === 'nonMembers') {
      const thunkArgs = {
        searchquery: searchquery || "",
        pageNumber: 1,

      }
      dispatch(fetchNonMembersList(thunkArgs));

    } else if (currentTab?.key === 'members') {
      const thunkArgs = {
        searchquery: searchquery || "",
        pageNumber: 1,

      }
      dispatch(fetchMembersList(thunkArgs));

    } else if (currentTab?.key === 'deleted') {
      const thunkArgs = {
        searchquery: searchquery || "",
        pageNumber: 1,

      }
      dispatch(fetchDeletedMembersList(thunkArgs));
    }
  }, [activeTab])


  const handleTabChange = (key: string) => {
    setActiveTab(key);
    setPageNumber(1);

    handleClearAll()
  };

  const handlePageChange = (page: number) => {
    setPageNumber(page);
  };

  const handleViewDetails = async (user: any) => {
    await dispatch(fetchNotesList({ id: user?.id }));
    const response = await dispatch(fetchONUserDetails(user?.id))
    //  const response = await dispatch(fetchONUserDetails(user?.id))
    const params: any = {
      on_user_id: user?.id
    }
    dispatch(fetchNotesList(params));
    // fetchNotesList(params)
    if (response?.payload?.isSuccess) {
      setSelectedUser(user);
      setIsUserDetailModalVisible(true);
    }
  };

  const handleModalClose = () => {
    setIsUserDetailModalVisible(false);
    setSelectedUser(null);
  };


  const nonMemberColumns = [
    {
      title: 'Member Name',
      dataIndex: 'display_name',
      key: 'display_name',

      render: (_: any, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} />
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{record.display_name}</div>
          </div>
        </div>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {

      title: 'Medical License Number',
      dataIndex: 'license_numbers',
      key: 'license_numbers',
      render: (numbers: string[]) => {

        // Handle no data
        if (!Array.isArray(numbers) || numbers.length === 0) {
          return 'N / A';
        }

        // Style object for license "pill"
        const pillStyle: React.CSSProperties = {

          padding: '4px 8px',
          borderRadius: '6px',
          display: 'inline-block',
          fontSize: '13px',
          fontWeight: 500,
          color: '#ffffffff'
        };

        // Only one license → show styled pill
        if (numbers.length === 1) {
          return <span style={pillStyle}>{numbers[0]}</span>;
        }

        // Multiple license numbers → first license + plus count
        return (
          <>
            <span style={pillStyle}>{numbers[0]}</span>
            <span
              onClick={() => handleShowLicenses(numbers)}
              style={{

                padding: '4px 6px',
                borderRadius: '6px',
                marginLeft: '6px',
                cursor: 'pointer',
                color: '#4554fa',
                fontSize: '13px',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              <PlusOutlined style={{ fontSize: '12px', marginRight: '2px' }} />
              {numbers.length - 1} more
            </span>
          </>
        );
      }
    },

    {
      title: 'Source of Request',
      dataIndex: 'source_of_reg_request',
      key: 'source_of_reg_request',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: UserData) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          style={{ fontSize: 12, height: 28 }}
          onClick={() => handleViewDetails(record)}
        >
          View
        </Button>
      ),
    },

  ];


  const memberColumns = [
    {
      title: 'Member Name',
      dataIndex: 'display_name',
      key: 'display_name',

      render: (_: any, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} />
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{record.display_name}</div>
          </div>
        </div>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Medical License Number',
      dataIndex: 'license_numbers',
      key: 'license_numbers',
      render: (numbers: string[]) => {

        // Handle no data
        if (!Array.isArray(numbers) || numbers.length === 0) {
          return 'N / A';
        }

        // Style object for license "pill"
        const pillStyle: React.CSSProperties = {
          // backgroundColor: '#f6f6ff',
          padding: '4px 8px',
          borderRadius: '6px',
          display: 'inline-block',
          fontSize: '13px',
          fontWeight: 500,
          color: '#ffffffff'
        };

        // Only one license → show styled pill
        if (numbers.length === 1) {
          return <span style={pillStyle}>{numbers[0]}</span>;
        }

        // Multiple license numbers → first license + plus count
        return (
          <>
            <span style={pillStyle}>{numbers[0]}</span>
            <span
              onClick={() => handleShowLicenses(numbers)}
              style={{
                backgroundColor: '#e9eafe',
                padding: '4px 6px',
                borderRadius: '6px',
                marginLeft: '6px',
                cursor: 'pointer',
                color: '#4554fa',
                fontSize: '13px',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              <PlusOutlined style={{ fontSize: '12px', marginRight: '2px' }} />
              {numbers.length - 1} more
            </span>
          </>
        );
      }
    },

    {
      title: 'Active Membership Plan',
      dataIndex: 'mm_plan_names',
      key: 'membership_plan',
      render: (plans: string[]) => (
        plans?.length > 0 ? (
          <Tag color="blue">{plans[0]}</Tag>
        ) : (
          "-"
        )
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: UserData) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          style={{ fontSize: 12, height: 28 }}
          onClick={() => handleViewDetails(record)}
        >
          View
        </Button>
      ),
    },
  ];

  const deletedColumns = [
    {
      title: 'Member Name',
      dataIndex: 'display_name',
      key: 'display_name',

      render: (_: any, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} />
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{record.display_name}</div>
          </div>
        </div>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {

      title: 'Medical License Number',
      dataIndex: 'license_numbers',
      key: 'license_numbers',
      render: (numbers: string[]) => {

        // Handle no data
        if (!Array.isArray(numbers) || numbers.length === 0) {
          return '-';
        }

        // Style object for license "pill"
        const pillStyle: React.CSSProperties = {

          padding: '4px 8px',
          borderRadius: '6px',
          display: 'inline-block',
          fontSize: '13px',
          fontWeight: 500,
          color: '#ffffffff'
        };

        // Only one license → show styled pill
        if (numbers.length === 1) {
          return <span style={pillStyle}>{numbers[0]}</span>;
        }

        // Multiple license numbers → first license + plus count
        return (
          <>
            <span style={pillStyle}>{numbers[0]}</span>
            <span
              onClick={() => handleShowLicenses(numbers)}
              style={{
                padding: '4px 6px',
                borderRadius: '6px',
                marginLeft: '6px',
                cursor: 'pointer',
                color: '#4554fa',
                fontSize: '13px',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              <PlusOutlined style={{ fontSize: '12px', marginRight: '2px' }} />
              {numbers.length - 1} more
            </span>
          </>
        );
      }
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: UserData) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          style={{ fontSize: 12, height: 28 }}
          onClick={() => handleViewDetails(record)}
        >
          View
        </Button>
      ),
    },
  ];

  const renderTableContent = () => {

    let columnsToRender;

    if (activeTab === 'nonMembers') {
      columnsToRender = nonMemberColumns;
    } else if (activeTab === 'members') {
      columnsToRender = memberColumns;
    } else if (activeTab === 'deleted') {
      columnsToRender = deletedColumns;
    }
    return (
      <div>
        <Table
          rowSelection={activeTab === "deleted" ? undefined : rowSelection}
          columns={columnsToRender}
          dataSource={updatedData || []}
          pagination={{
            position: ["bottomRight"],
            // Must match ITEMS_PER_PAGE in the superadmin API (20): the server
            // returns 20 rows per page, and a smaller pageSize made AntD slice
            // them again client-side, hiding 5 rows of every page.
            pageSize: 20,
            current: pageNumber,
            onChange: (page) => handlePageChange(page),
            total: totalCount,
            showSizeChanger: false,
            showQuickJumper: true,
            showTotal: (total, range) => (
              <div className="pagniation-text">
                {`${range[0]}-${range[1]} of ${total} items`}
              </div>
            ),
          }}
          rowKey="id"
          size="small"
          style={{ fontSize: 13 }}
        />
      </div>
    );
  };

  const tabItems = TABS.map(tab => ({
    label: tab.label,
    key: tab.key,
    children: isLoading ? (
      <div style={{ padding: '20px' }}>
        <Skeleton active paragraph={{ rows: 8 }} />
      </div>
    ) : (
      renderTableContent()
    ),
  }));

  return (
    <div className="request-lists-container">

      <Row className="button-container" gutter={[16, 16]} align="middle" justify="space-between">
        {/* Left section: Search */}
        <Col xs={24} sm={24} md={12}>
          <Row gutter={8} align="middle">
            <Col flex="auto">
              <span className="search-bar">
                <Input
                  placeholder="Search"
                  prefix={<LiaSearchSolid className="search-bar-icon" />}
                  onChange={(e) => setSearchquery(e.target.value)}
                />
              </span>
            </Col>
            <Col>
              <SimpleButton
                text="Search"
                color="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
              />
            </Col>
          </Row>
        </Col>
      </Row>


      <Modal
        title="Medical License Number"
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        bodyStyle={{
          backgroundColor: "#21262c", // dark background
          padding: "16px",
          maxHeight: "400px",
          overflowY: "auto"
        }}
        style={{
          top: 20
        }}
      >
        {licenseNumbers.length > 0 ? (
          <List
            dataSource={licenseNumbers}
            renderItem={(item) => (
              <List.Item
                style={{
                  backgroundColor: "#11161c",
                  color: "#fff",
                  marginBottom: "8px",
                  borderRadius: "6px",
                  padding: "10px 12px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <span>{item}</span>

              </List.Item>
            )}
          />
        ) : (
          <p style={{ color: "#c7cace" }}>No license numbers available.</p>
        )}
      </Modal>
      <NonMemberListAction
        selectedRows={selectedRows}
        // fetchUsersListData={updatedData}
        activeTab={activeTab}
        selectedAlphabet={selectedAlphabet}
        onSpecialityChange={handleSpecialityChange}
        onSiteChange={handleSiteChange}
        onActiveChange={handleActiveChange}
        onClearAll={handleClearAll}
        onRoleChange={handleRoleChange}
        setUseSelectedRows={setSelectedRows}
        resetTableSelection={resetTableSelection}
        selectedSpeciality={undefined}
        roleCheckedList={undefined}
        onFilterResults={(filtered) => setUpdatedData(filtered)} // <-- here
        setUpdatedData={setUpdatedData}
      />
      <Tabs
        items={tabItems}
        defaultActiveKey="nonMembers"
        activeKey={activeTab}
        onChange={handleTabChange}
        className="request-lists-tabs"
        tabBarExtraContent={
          activeTab !== "deleted" ?
            <div className="register-user-btn-wrapper" style={{ display: "flex", gap: "8px" }}>
              <SimpleButton opacity={selectedRowIds?.length === 0 ? 0.5 : 1} disabled={selectedRowIds?.length === 0}
                text="Delete "
                color="danger-default"
                onClick={handleDeleteUser}
              />
            </div>
            : null
        }
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "10px 0",
        }}
      >

      </div>

      <UserDetailsModal
        fromMemberPage={true}
        isVisible={isUserDetailModalVisible && userDetailsData}
        // user={selectedUser}
        user={userDetailsData}
        onClose={handleModalClose}
        onAccept={() => { }}
        onReject={() => { }}
        currentTab={activeTab}
        onEdit={() => { }}
        onDelete={() => { }}
        onVerifyLicense={() => { }}
        onRejectLicense={() => { }}
        onEditLicense={() => { }}
        onSaveLicense={() => { }}

      />

    </div>
  );
}
